import { render, staticRenderFns } from "./filePlayer.vue?vue&type=template&id=7a21887a&"
import script from "./filePlayer.vue?vue&type=script&lang=js&"
export * from "./filePlayer.vue?vue&type=script&lang=js&"
import style0 from "./filePlayer.vue?vue&type=style&index=0&id=7a21887a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports